import { render, staticRenderFns } from "./CurrentHoldingsChart.vue?vue&type=template&id=912f104e&scoped=true"
import script from "./CurrentHoldingsChart.vue?vue&type=script&lang=ts"
export * from "./CurrentHoldingsChart.vue?vue&type=script&lang=ts"
import style0 from "./CurrentHoldingsChart.vue?vue&type=style&index=0&id=912f104e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912f104e",
  null
  
)

export default component.exports